import {
  DEATH_WAVE,
  GOLDEN_TOWER,
  BLACK_HOLE,
  SPOTLIGHT,
  SMART_MISSILES,
  CHRONO_FIELD,
  POISON_SWAMP,
  INNER_LAND_MINES,
  CHAIN_LIGHTNING,
} from 'utils/constants';
import BlackHole from './BlackHole';
import ChainLightning from './ChainLightning';
import ChronoField from './ChronoField';
import DeathWave from './DeathWave';
import GoldenTower from './GoldenTower';
import InnerLandMines from './InnerLandMines';
import PoisonSwamp from './PoisonSwamp';
import SmartMissiles from './SmartMissiles';
import SpotLight from './Spotlight';
import './Results.scss';

const ShowAll = () => {
  const noUW = {
    [DEATH_WAVE]: false,
    [GOLDEN_TOWER]: false,
    [BLACK_HOLE]: false,
    [SPOTLIGHT]: false,
    [SMART_MISSILES]: false,
    [CHRONO_FIELD]: false,
    [POISON_SWAMP]: false,
    [INNER_LAND_MINES]: false,
    [CHAIN_LIGHTNING]: false,
  };
  const params = {
    unlocked: noUW,
    currentCount: 0,
    choices: noUW,
    showAll: true,
  };
  return (
    <div className='show-all'>
      <ChainLightning {...params} />
      <SpotLight {...params} />
      <BlackHole {...params} />
      <ChronoField {...params} />
      <InnerLandMines {...params} />
      <SmartMissiles {...params} />
      <PoisonSwamp {...params} />
      <GoldenTower {...params} />
      <DeathWave {...params} />
    </div>
  );
};

export default ShowAll;
